import { NavLink } from "react-router-dom";

const navItems = [
  { label: "Home", path: "/dashboard", icon: "🏠" },
  { label: "Projects", path: "/projects", icon: "📁" },
  { label: "Tasks", path: "/tasks", icon: "✅" },
  { label: "Bugs", path: "/bugs", icon: "🐞" },
  { label: "Skills", path: "/skills", icon: "🧠" }, // ✅ ADDED
  { label: "Payments", path: "/payments/overdue", icon: "💰" },
];

const MobileBottomNav = () => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t md:hidden z-50">
      <ul className="flex justify-around">
        {navItems.map((item) => (
          <li key={item.path} className="flex-1">
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center py-2 text-xs transition ${
                  isActive
                    ? "text-blue-600 font-semibold"
                    : "text-gray-500"
                }`
              }
            >
              <span className="text-lg">{item.icon}</span>
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default MobileBottomNav;
